// Additional analytics must wait for an explicit analytics choice, including outside consent-required regions.
(() => {
  let loaded = false;
  function update() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || loaded) return;
    if (privacy.currentVisitorConsent()?.analytics !== 'yes' || !privacy.analyticsProcessingAllowed()) return;
    loaded = true;
    const script = document.createElement('script');
    script.src = 'https://analytics.ahrefs.com/analytics.js'; script.dataset.key = 'tYd+Nq1q1mJyYiTnHonOsA'; script.async = true;
    document.head.append(script);
  }
  document.addEventListener('visitorConsentCollected', update);
  function init() {
    if (window.Shopify?.customerPrivacy) update();
    else window.Shopify?.loadFeatures?.([{ name:'consent-tracking-api', version:'0.1' }], error => { if (!error) update(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true }); else init();
})();
